import React from 'react';
import { OrbitComponent } from '../../../../base-components/orbit-component/orbit-component';
import { GameImageAnimatedBox } from '../../boxes/game-image/game-image-animated.box';
import { IGameAnimatedIconRegistrationResult } from '../../../../../services/game-animated-icons-manager/game-animated-icons-manager.service.interface';

interface IGameImageComponentProps {
    animationJsonUrl: string;
    animationTiming: {
        delay: number;
        interval: number;
    }
    width: number;
    height: number;
    useSquareIcons?: boolean;
    onAnimationLoad?(): void;
    onAnimationBeforeUnload?(): void;
    onAnimationUnload?(): void;
}

export class GameImageAnimatedComponent extends OrbitComponent<IGameImageComponentProps> {
    private animatedImageWrapper: HTMLElement | null = null;
    private pixiAnimationRegistration: IGameAnimatedIconRegistrationResult | null = null;

    private _captureAnimatedImageElementRef = (element: HTMLElement) => {
        this.animatedImageWrapper = element;
        // cancelAnimationRequest
        if (this.pixiAnimationRegistration) {
            this.pixiAnimationRegistration.unregister();
            this.pixiAnimationRegistration = null;
        }
        if (element) {
            // requestAnimation
            this.loadPixiAnimatedIcon();
        }
        this.animatedImageWrapper = element;
    };

    private async loadPixiAnimatedIcon() {
        this.pixiAnimationRegistration = this.services.gameAnimatedIconsManager.register({
            jsonUrl: this.props.animationJsonUrl,
            size: {
                width: this.props.width, height: this.props.height
            },
            wrapper: this.animatedImageWrapper,
            timings: this.props.animationTiming,
            onAnimationLoad: () => {
                if (this.props.onAnimationLoad) {
                    this.props.onAnimationLoad();
                }
            },
            onAnimationBeforeUnload: () => {
                if (this.props.onAnimationBeforeUnload) {
                    this.props.onAnimationBeforeUnload();
                }
            },
            onAnimationUnload: () => {
                if (this.props.onAnimationUnload) {
                    this.props.onAnimationUnload();
                }
            }
        });
    }

    render() {
        return <GameImageAnimatedBox
            ref={this._captureAnimatedImageElementRef}
        />
    }
}
